<template>
    <horizontal-scroll-outer-wrapper v-if="xAxisScroll">
        <horizontal-scroll-inner-wrapper class="space-x-2">
            <div class="flex">
                <slot />
            </div>
        </horizontal-scroll-inner-wrapper>
    </horizontal-scroll-outer-wrapper>
    <div v-else class="space-y-2 -mt-2">
        <slot />
    </div>
</template>

<script>
    import HorizontalScrollInnerWrapper from '../HorizontalScrollInnerWrapper.vue';
    import HorizontalScrollOuterWrapper from '../HorizontalScrollOuterWrapper.vue';

    export default {
        components: { HorizontalScrollOuterWrapper, HorizontalScrollInnerWrapper },
        props: {
            xAxisScroll: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>